module.exports = __webpack_public_path__ + "media/customizations/riverland/logo-58f25a35354952c2e9060ec7e4d846a5.png";